import apiHeader from '@/helpers/apiHeader';

const noteService = {
    list(params) {
        return apiHeader.get('navbar/note', { params });
    },
    create(params) {
        return apiHeader.post('navbar/note', params);
    },
    detail(id) {
        return apiHeader.get(`navbar/note/${id}`);
    },
    patch(id, params) {
        return apiHeader.patch(`navbar/note/${id}`, params);
    },
    delete(id) {
        return apiHeader.delete(`navbar/note/${id}`);
    },
}

export default noteService; 